import React, { useEffect } from "react";
import styles from "./playQuiz.module.css";
import { GetQuizDataById, logQuizImpression } from "../../apis/quiz";
import { logAnswer } from "../../apis/quiz";
import { logVotingCount } from "../../apis/quiz";
import { useState } from "react";

export default function PlayQuiz({
  setQuizData,
  quizData,
  setCurrentQuesIndex,
  currentQuesIndex,
  setQuizSuccess,
  setPollSuccess,
  setCorrectAnswersCount,
  answerIndexSelected,
  setAnswerIndexSelected,
}) {
  const [timeLeftArray, setTimeLeftArray] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectionError, setSelectionError] = useState("");

  useEffect(() => {
    if (quizData?.data?.questions) {
      setTimeLeftArray(
        quizData.data.questions.map(
          () => quizData?.data?.timer_for_eachQuestion
        )
      );
    }
  }, [quizData]);

  useEffect(() => {
    if (quizData?.data?.timer_for_eachQuestion) {
      const intervalId = setInterval(() => {
        setTimeLeftArray((prevArray) => {
          const newArray = [...prevArray];
          if (newArray[currentQuesIndex] > 0){
            newArray[currentQuesIndex] -= 1;
          }
          return newArray;
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [currentQuesIndex, quizData]);
  useEffect(() => {
    const fetchQuizData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const quizId = urlParams.get("quizId");
      try {
        const quizData = await GetQuizDataById(quizId);
        setQuizData(quizData);
      } catch (error) {
        console.error(error);
        setErrorMessage("We couldn't load this quiz. Check the link and try again.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchQuizData();
  }, [setQuizData]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const quizId = urlParams.get("quizId");
    logQuizImpression(quizId);
  }, []);

  function handleAnswerSelection(optionIndex) {
    setAnswerIndexSelected(optionIndex);
    setSelectionError("");
  }

  const handleNext = async () => {
    if (answerIndexSelected === undefined) {
      setSelectionError("Choose an answer before continuing.");
      return;
    }

    const quizObject = quizData.data;
    const questionsArray = quizObject.questions;
    const questionId = questionsArray?.[currentQuesIndex]._id;

    if (quizObject.quizType === "Poll Type") {
      await logVotingCount(
        quizData?.data?._id,
        currentQuesIndex,
        answerIndexSelected
      );
      setPollSuccess(true);
    } else {
      await logAnswer(questionId, answerIndexSelected);
      if (answerIndexSelected === questionsArray[currentQuesIndex]?.correct_answer_index) {
        setCorrectAnswersCount((prevCount) => prevCount + 1);
      }
      if (questionsArray.length === currentQuesIndex + 1) {
        setQuizSuccess(true);
      } else {
        setCurrentQuesIndex((prevIndex) => prevIndex + 1);
        setAnswerIndexSelected(undefined);
      }
    }
  };

  const quizObject = quizData.data;

  if (isLoading) return <div className={styles.statePage}><div className={styles.loader} aria-label="Loading quiz"/><p>Preparing your quiz…</p></div>;
  if (errorMessage || !quizObject) return <div className={styles.statePage}><div className={styles.stateCard}><span className={styles.stateIcon}>!</span><h1>Quiz unavailable</h1><p>{errorMessage || "This quiz could not be found."}</p><button onClick={() => window.location.reload()}>Try again</button></div></div>;

  const question = quizObject.questions[currentQuesIndex];

  return (
    <div className={styles.playQuiz_container}>
      <div className={styles.quiz_questions_wrapper}>
        <div className={styles.quizBrand}><span>Q</span> Quizzie</div>
        <div className={styles.questions_header}>
          <div className={styles.questionCount}>
            Question {currentQuesIndex + 1} <span>of {quizObject.questions.length}</span>
          </div>
          {quizData?.data?.quizType === "Q & A" && (
            <div className={styles.timer} aria-label={`${timeLeftArray[currentQuesIndex]} seconds remaining`}>
              {timeLeftArray[currentQuesIndex] !== "OFF" && (
                <span>{timeLeftArray[currentQuesIndex]}</span>
              )}
              <span style={{ marginLeft: "5px" }}>
                {timeLeftArray[currentQuesIndex] === "OFF" ? "OFF" : "Sec"}
              </span>
            </div>
          )}
        </div>
        <div className={styles.progressTrack} aria-hidden="true"><div style={{width:`${((currentQuesIndex + 1) / quizObject.questions.length) * 100}%`}} /></div>
        <div className={styles.questions}>
          <h1>{question.questionTitle}</h1>
          <div className={styles.options_wrapper_text}>
            {question.options.map((option, optionIndex) => (
              <div key={optionIndex}>
                {question.optionType === "Text" && option.text !== "" && (
                  <button type="button"
                    className={`${styles.option} ${
                      answerIndexSelected === optionIndex ? styles.selected : ""
                    }`}
                    aria-pressed={answerIndexSelected === optionIndex} onClick={() => handleAnswerSelection(optionIndex)}>
                    {option.text}
                  </button>
                )}

                {question.optionType === "Image URL" && option.imageUrl !== "" && (
                  <button type="button"
                    className={`${styles.option} ${styles.ImageOption} ${
                      answerIndexSelected === optionIndex ? styles.selected : ""
                    }`}
                    onClick={() => handleAnswerSelection(optionIndex)} aria-pressed={answerIndexSelected === optionIndex}>
                    <img
                      src={option.imageUrl}
                      className={styles.playQuizImg}
                      alt={option.text || `Answer option ${optionIndex + 1}`}
                    ></img>
                  </button>
                )}

                {question.optionType === "Text & Image URL" &&
                  option.text !== "" &&
                  option.imageUrl !== "" && (
                    <button type="button"
                      className={`${styles.option} ${styles.ImageOption} ${
                        answerIndexSelected === optionIndex
                          ? styles.selected
                          : ""
                      }`}
                      onClick={() => handleAnswerSelection(optionIndex)} aria-pressed={answerIndexSelected === optionIndex}>
                      <div className={styles.textImg_wrapper}>
                        <div>{option.text}</div>
                        <img
                          src={option.imageUrl}
                          alt=""
                          className={styles.playQuizImg}
                        ></img>
                      </div>
                    </button>
                  )}
              </div>
            ))}
          </div>
        </div>
        {selectionError && <p className={styles.selectionError} role="alert">{selectionError}</p>}
        <button className={`${styles.submit_quiz_btn}`} onClick={handleNext}>
          {currentQuesIndex === quizObject.questions.length - 1
            ? "Submit"
            : "Next"}
        </button>
      </div>
    </div>
  );
}
